import React from 'react';
import { AvatarUI } from '@components/main-components/avatar/Avatar';
import { webappUriPath } from '@utils/url';

export function Avatar({
  webappUri,
  ...props
}: {
  webappUri: string;
} & Omit<React.ComponentProps<typeof AvatarUI>, 'webappUriPath'>) {
  return <AvatarUI {...props} webappUriPath={webappUriPath(webappUri)} />;
}
